import { withStyles, withTheme, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import * as ETLProgressAnimation from './../../../animations/json/ETLProgress.json';
import AnimationRenderer from '../../../animations/animationRenderer';
import { compose } from 'recompose';

const styles = (theme) => ({
  etlProgressDialog: {
    height: '440px',
    textAlign: 'center',
    padding: '22px',
    boxSizing: 'border-box',
    borderRadius: '2px',
    backgroundColor: theme.ModalBGColor,
    boxShadow: '2px 2px 4px black'
  },
  etlProgressTitle: {
    fontSize: theme.headerTextFontSize16,
    fontWeight: '600',
    lineHeight: '22px',
    color: theme.HeaderSelectedText,
    padding: '0px',
    paddingBottom: '16px'
  },
  etlProgressContent: {
    fontSize: theme.textFontSize,
    lineHeight: '17px',
    overflow: 'hidden',
    color: theme.TextColor
  }
});

const ETLProgressDialog = (props) => {
  const { classes, show, planDate, theme } = props;
  return (
    <Dialog
      open={show}
      classes={{ paper: classes.etlProgressDialog }}
      className={`dialog ${theme.themeName}`}
      aria-labelledby="etl-progress">
      <DialogTitle
        disableTypography={true}
        classes={{ root: classes.etlProgressTitle }}
        id="etl-progress">
        Loading New Data
      </DialogTitle>
      <DialogContent className={classes.etlProgressContent}>
        <div>Data for {planDate} plan date will be ready soon!</div>
        <AnimationRenderer animationJSON={ETLProgressAnimation} dimension="400px" />
      </DialogContent>
    </Dialog>
  );
};

export default compose(withStyles(styles), withTheme())(ETLProgressDialog);
